/**
 * Rounds a number to two decimal places.
 *
 * @param num - The number to round
 * @returns The rounded number with two decimal places
 *
 * @example
 * roundToTwoDecimals(2.345) // returns 2.35
 * roundToTwoDecimals(2.344) // returns 2.34
 */

export function roundToTwoDecimals(num: number): number {
	return Math.round(num * 100) / 100;
}
